import { fromJS } from 'immutable';
import { SET_EXISTANT_CLAIMS } from 'containers/ManagerDocumentsPage/constants';

export interface ExistantClaimsAction {
  type: string;
  existantClaims: any;
}

const initialState: any = fromJS({
  existantClaims: [],
});

const existantClaimsReducer = (
  state = initialState,
  action: ExistantClaimsAction,
) => {
  switch (action.type) {
    case SET_EXISTANT_CLAIMS:
      return state.set('existantClaims', fromJS(action.existantClaims));
    default:
      return state;
  }
};

export default existantClaimsReducer;
